import { InstancesStore, AppDataSync } from '../Analytics/context';
import { Firebase } from './Firebase';
import { firebaseConfigData } from './Firebase.constants';

export const getFirebaseInstances = (appDataSync: AppDataSync) => {
  const firebaseConfigs = appDataSync?.firebase;
  const firebaseInstances: InstancesStore = {};
  const defaultInstanceName = 'DEFAULT_FIREBASE_ANALYTICS';

  if (firebaseConfigs?.default && !firebaseInstances[defaultInstanceName]) {
    const FirebaseInit = new Firebase();

    FirebaseInit.initializeFirebaseInstance(
      firebaseConfigData,
      defaultInstanceName
    );

    firebaseInstances[defaultInstanceName] = {
      mode: 'firebase',
      instance: FirebaseInit,
    };
  }

  if (firebaseConfigs?.configs) {
    firebaseConfigs.configs.forEach(instance => {
      if (!firebaseInstances[instance.name]) {
        const FirebaseInit = new Firebase();

        FirebaseInit.initializeFirebaseInstance(
          instance.firebaseConfig,
          instance.name
        );

        firebaseInstances[instance.name] = {
          mode: 'firebase',
          instance: FirebaseInit,
        };
      }
    });
  }

  return firebaseInstances;
};
